import type { FunctionMeta } from '../function.model';

// =============================================================================
// PARAMS - Mathematical definition
// =============================================================================

/** Cubic function parameters in vertex form: a(x-h)³ + k */
export interface CubicParams {
  /** Vertical scale/reflection */
  a: number;
  /** Horizontal shift (inflection point x-coordinate) */
  h: number;
  /** Vertical shift (inflection point y-coordinate) */
  k: number;
}

// =============================================================================
// META - Function configuration (type-checked)
// =============================================================================

/**
 * Configuration metadata for cubic functions.
 * Translate behaviors map to h (x) and k (y) parameters.
 */
export const CUBIC_META: FunctionMeta<CubicParams> = {
  availableFeatures: [
    'handle',
    'roots',
    'extrema',
    'tangent',
    'secant',
    'derivative',
    'inflection',
    'intersection',
    'yIntercept',
    'trajectory',
    'monotonicity',
    'functionArea',
    'intersectionArea',
    'domain',
    'range',
  ],
  handleConfigs: {
    translate: { xParam: 'h', yParam: 'k' },
    'translate-x': { xParam: 'h', yParam: 'k' },
    'translate-y': { xParam: 'h', yParam: 'k' },
  },
  defaultParams: {
    a: 1,
    h: 0,
    k: 0,
  },
  defaultRanges: {
    a: [-5, 5],
    h: [-10, 10],
    k: [-10, 10],
  },
};
